import React, { useState, useEffect, Fragment } from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import {
  getNews,
  News,
  Link,
  getLinks,
  getMinimumEthicsBanner,
  MinimumEthicsBanner,
} from 'features/contents/contentsAPI';
import Loader from 'components/TableLoader';
import { formatDate } from 'helpers/formatDate';
import config from 'config';

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const [news, setNews] = useState<News[]>([]);
  const [links, setLinks] = useState<Link[]>([]);
  const [banner, setBanner] = useState<MinimumEthicsBanner | null>(null);

  useEffect(() => {
    setIsLoading(true);

    Promise.allSettled([getNews(), getLinks(), getMinimumEthicsBanner()])
      .then(results => {
        const [newsResult, linksResult, bannerResult] = results;

        if (newsResult.status === 'fulfilled') {
          setNews(newsResult.value);
        } else {
          console.error(newsResult.reason);
        }

        if (linksResult.status === 'fulfilled') {
          setLinks(linksResult.value);
        } else {
          console.error(linksResult.reason);
        }

        if (bannerResult.status === 'fulfilled') {
          setBanner(bannerResult.value);
        } else {
          console.error(bannerResult.reason);
        }
      })
      .finally(() => setIsLoading(false));
  }, []);


  if (isLoading) {
    return (
      <div className="content">
        <Row>
          <Col style={{ textAlign: 'center' }}>
            <Loader />
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className="content">
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <Row>
                <Col md={8} className="d-flex flex-column">
                  <h3>Novedades</h3>
                  <hr style={{ margin: '0 0 0.75rem' }} />
                  {
                    news && news.length
                      ? news.map(row => (
                        <Row key={ row.id }>
                          <Card style={{ boxShadow: 'none' }}>
                            <CardHeader
                              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            >
                              <h3 style={{ marginBottom: 0 }}>{ row.title }</h3>
                              <span>{ formatDate(row.createdAt) }</span>
                            </CardHeader>
                            <CardBody>
                              {
                                row.content.split(/\r?\n/).map((line, idx) => (
                                  <Fragment key={ idx }>
                                    {line}
                                    <br />
                                  </Fragment>
                                ))
                              }
                            </CardBody>
                          </Card>
                        </Row>
                      ))
                      : null
                  }
                  {
                    banner && (
                      <div className="mb-4 mt-auto">
                        <a
                          href={`${config.baseUrl}/${encodeURI(banner.url)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`${config.baseUrl}/${encodeURI(banner.image)}`}
                            alt="Mínimo Ético"
                            style={{ maxWidth: '100%', height: '300px', display: 'block' }}
                          />
                        </a>
                      </div>
                    )
                  }
                </Col>
                <Col md={4}>
                  <h3>Enlaces</h3>
                  <hr style={{ margin: '0 0 0.75rem' }} />
                  {
                    links && links.length
                      ? links.map(link => (
                        <p key={ link.id }>
                          <a href={ link.url}>{ link.name }</a>
                          &nbsp;
                          <small>{ link.description }</small>
                        </p>
                      ))
                      : null
                  }
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
